import * as urls from '@apps-common/js-client/api/urls.js';

urls.setBase('https://api.planet.com/');

// Environments -----------------------------------------------------------

export const ENVS = {
  local: 'local',
  staging: 'staging', // internal (static), does not mean staging auth/API
  production: 'production',
};

export const DEPLOY_ENV = import.meta.env.VITE_DEPLOY_ENV ?? ENVS.local;

// API URLs ---------------------------------------------------------------

export const MOSAICS_API_URL = urls.base('basemaps', 'v1', 'mosaics');
export const ANIMATIONS_API_URL =
  import.meta.env.VITE_ANIMATIONS_API_URL ||
  urls.base('explorer', 't2', 'animations');

export const TILES_BASE_URL = 'https://tiles{0-3}.planet.com';
export const ITEM_TILES_BASE_URL = `${TILES_BASE_URL}/v1/experimental/tiles`;
export const MOSAIC_TILES_BASE_URL = `${TILES_BASE_URL}/experimental/mosaics/planet-tiles`;

const publicUrl = 'https://www.planet.com';
export const PLAYER_URL = `${publicUrl}/stories`;
export const COMPARE_URL = `${publicUrl}/compare`;
export const EXPLORER_URL = `${publicUrl}/explorer`;

export const ASSETS_URL = 'https://storage.googleapis.com/planet-t2';

export const GEOCODER_API_URL =
  'https://api.mapbox.com/geocoding/v5/mapbox.places';

export const GLOBAL_MOSAICS = urls.base(
  'basemaps',
  'v1',
  'series',
  '431b62a0-eaf9-45e7-acf1-d58278176d52',
  'mosaics',
);

export const RULES = urls.base('basemaps', 'v1', 'rules');

// MapBox -----------------------------------------------------------------

// Dev Token Open to ALL do NOT copy into other apps!
export const MAPBOX_TOKEN =
  import.meta.env.VITE_MAPBOX_TOKEN ||
  'pk.eyJ1IjoicGxhbmV0IiwiYSI6ImNrOTBhYWk3cDBoemszbG11bHQ1enVodjMifQ.yv8qxqOEs2m2ndD4F-c-lA';

export const LABELS_STYLE_URL =
  'mapbox://styles/planet/ck9qfizat2wz81ip84e3ac018';

// LaunchDarkly -----------------------------------------------------------

export const LD_CLIENTSIDE_ID =
  import.meta.env.VITE_LD_CLIENTSIDE_ID ??
  {
    production: import.meta.env.VITE_LD_CLIENTSIDE_ID_PROD,
    staging:
      import.meta.env.VITE_LD_CLIENTSIDE_ID_STAGING ??
      '662b9f3a0a3e70106fd55f61',
    local:
      import.meta.env.VITE_LD_CLIENTSIDE_ID_LOCAL ?? '662b9f49db0cc60fb29d0302',
  }[DEPLOY_ENV ?? ENVS.local];
